import {
  FormControl,
  FormControlProps,
  FormLabel,
  FormHelperText,
  Grid,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';

type CustomMuiFormControlProps = Omit<FormControlProps, 'title'>;

export interface CheckboxGroupProps extends CustomMuiFormControlProps {
  className?: string;
  /**
   * Title of checkbox group
   */
  title?: React.ReactNode;
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error?: boolean;
  /**
   * The helper text content.
   */
  helperText?: React.ReactNode;
}

const CheckboxGroupImpl = React.forwardRef<HTMLDivElement, CheckboxGroupProps>(
  ({ className, title, error, helperText, children, ...props }, ref) => {
    return (
      <Grid container {...props} className={className}>
        <Grid item className="checkbox-container">
          <FormLabel component="legend" error={error}>
            {title}
          </FormLabel>
          <Arranger className="checkbox-group" direction="column" ref={ref}>
            {children}
          </Arranger>
          <FormHelperText error={error}>{helperText}</FormHelperText>
        </Grid>
      </Grid>
    );
  }
);

export const CheckboxGroup = muiStyled(CheckboxGroupImpl)(({
  theme,
  error,
}) => {
  return css`
    padding: 16px 16px 24px;

    .checkbox-container {
      width: 100%;
    }

    legend.Mui-focused {
      color: ${error ? theme.palette.error.main : theme.palette.text.primary};
    }

    .checkbox-group {
      margin-left: 9px;
    }

    .MuiFormHelperText-root {
      margin-left: 0;
    }
  `;
});

export default CheckboxGroup;
